import getCookie from '../../../../../common/cookies';
import { ISSOToWindow } from './sso-to-window.interface';
import { SSOUtils } from '../../../utils/sso.utils';

export class SSOToWindow implements ISSOToWindow {
  private ssoUtils: SSOUtils;

  constructor(ssoUtils: SSOUtils) {
    this.ssoUtils = ssoUtils;
  }

  exchangeTokenWhenReceiveReadySignal(destination: string, redirectTo: string): void {
    window.addEventListener('message', (event) => {
      const validOrigin = this.ssoUtils.isValidOrigin(event.origin);
      if (event.source && validOrigin && event.data?.status === 'ready') {
        event.source.postMessage(this.getMessageToPost(destination, redirectTo), { targetOrigin: event.origin });
      }
    });
  }

  private getMessageToPost(destination: String, redirectTo: String) {
    let mhToken = getCookie('MH_TOKEN');
    return  {
      source: 'mheducation',
      destination: destination,
      token: mhToken,
      redirectUrl: redirectTo,
      nonce: this.ssoUtils.generateNonce(8),
    }
  }
}
